import { getZone } from '@bratva/content';
import { nightRaid, patrolsAt, raidChance, streamRng, watchedBy, type Patrol } from '@bratva/rules';
import type { Action, SaveDoc } from '@bratva/state';
import { flashiness } from './character.js';

/**
 * Палево и мусора. Патрули не хранятся в сейве: их положение выводится
 * из сида, дня и минуты, поэтому «где стоял патруль в 14:20» всегда
 * восстанавливается по сейву — и в отладке, и при разборе жалобы.
 */

/** Сколько отберут при облаве: часть налички. Хабар забирают целиком. */
const RAID_CASH_SHARE = 0.15;

export function patrolsNow(save: SaveDoc): Patrol[] {
  const zone = getZone(save.player.zone);
  // Гелик и малиновый пиджак видно издалека — приметность идёт в радиус.
  return patrolsAt(save.seed, save.day, save.minute, zone.id, zone.patrols, save.player.heat, flashiness(save));
}

/** Стоит ли пацан на глазах у патруля прямо сейчас. */
export function watchedNow(save: SaveDoc): Patrol | null {
  return watchedBy(patrolsNow(save), save.player.tile);
}

function raidAction(save: SaveDoc, reason: string): Action {
  return {
    type: 'raid',
    lostCash: Math.round(save.player.cash * RAID_CASH_SHARE),
    lostHabar: save.habar.length,
    reason,
  };
}

/**
 * Попался на глаза с высоким палевом — бросок на облаву.
 * Проверяется после каждого действия, которое стоило времени.
 */
export function raidIfCaught(save: SaveDoc): Action | null {
  const chance = raidChance(save.player.heat);
  if (chance <= 0) return null;
  if (!watchedNow(save)) return null;

  const rng = streamRng(save.seed, `raid:${save.minute}:${save.player.tile.x}-${save.player.tile.y}`, save.day);
  if (!rng.chance(chance)) return null;
  return raidAction(save, 'Патруль взял с поличным');
}

/** С палевом за восемьдесят до утра можно и не дожить. */
export function raidIfHotOvernight(save: SaveDoc): Action | null {
  const rng = streamRng(save.seed, 'raid:night', save.day);
  if (!nightRaid(save.player.heat, rng)) return null;
  return raidAction(save, 'Ночью приехали с обыском');
}
